import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Stack, TextField, FormControl } from '@mui/material';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';

import './button.css';

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.padding,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(2),
    }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
            display: true,
        },
        title: {
            display: true,
            text: 'Gráfico de Atendimento',
            position: 'left',
        },
        datalabels: {
            display: true,
            anchor: 'start',
            offset: -30,
            align: "start",
            color: "#fff",
            textStrokeColor: "#000",
            textStrokeWidth: 2,
            font: {
                size: 20,
                weight: "bold"

            },
        },
    },
    scale: {
        y: {
            beginAtZero: true, 
            ticks: {
                stepSize: 1,
                precision: 0,
                callback: function(value) {
                    return Number.isInteger(value) ? value : null;
                }
            }
        }
    }
};

export const ChatsUserFilter = () => {
    // const classes = useStyles();
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [allUserNames, setAllUserNames] = useState([]); // Estado para todos os usuários

    const [ticketsData, setTicketsData] = useState({ data: [] });
    const [ticketsDataClosed, setTicketsDataClosed] = useState({ data: [] });

    const [personName, setPersonName] = React.useState(["Todos"]);
    
    const companyId = localStorage.getItem("companyId");
    
    useEffect(() => {
        handleGetTicketsInformation();
        
    }, []);

    useEffect(() => {
        // Atualiza todos os nomes de usuários no estado allUserNames
        const uniqueNames = [...new Set(ticketsData?.data.map((item) => item.nome))];
        setAllUserNames((prevNames) => [...new Set([...prevNames, ...uniqueNames])]);
    }, [ticketsData]);
    
    const nomesUnicos = allUserNames;

    const dataCharts = {

        labels: personName.includes("Todos") ? nomesUnicos : personName,
        datasets: [
            {
                data: (personName.includes("Todos") ? nomesUnicos : personName).map((nome) => {
                    // Soma as quantidades onde o status é "open" e o nome é igual
                    return ticketsData?.data
                        .filter((item) => item.nome === nome && item.status === 'open')
                        .reduce((total, item) => total + item.quantidade, 0);
                }),
                backgroundColor: '#1FA0DB',
                label: 'Atendimentos em Andamento'
            },
            {
                data: (personName.includes("Todos") ? nomesUnicos : personName).map((nome) => {
                    // Garante que ticketsDataClosed.data é um array antes de filtrar
                    return  ticketsDataClosed?.data.dataClosed
                              .filter((item) => item.nome === nome)
                              .reduce((total, item) => total + item.quantidade, 0)
                }),
                backgroundColor: '#B5D336',
                label: 'Atendimentos Encerrados'
            },            

        ],
    };

    const handleGetTicketsInformation = async () => {
        try {

            const { data } = await api.get(`/dashboard/ticketsFilteredUserOpen?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}&usuarios=${personName}`);

            const { data: dataClosed } = await api.get(`/dashboard/ticketsFilteredUserClosed?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);

            setTicketsDataClosed({data: dataClosed});
            setTicketsData(data); 
        } catch (error) {
            toast.error('Erro ao obter informações da conversa');
        }
    }

    const handleChange = (event) => {
        const { value } = event.target;

        if (value.includes("Todos")) {
            // Se "Todos" for selecionado, seleciona todos os nomes
            if (personName.includes("Todos")) {
                setPersonName([]); // Desmarca tudo se "Todos" já estiver selecionado
            } else {
                setPersonName(nomesUnicos); // Seleciona todos os nomes
            }
        } else {
            setPersonName(value); // Seleção padrão
        }

      };   

    return (
        <>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                Total de Atendimentos por Usuário
            </Typography>

            <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ my: 2, }} >

                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                    <DatePicker
                        value={initialDate}
                        onChange={(newValue) => { setInitialDate(newValue) }}
                        label="Inicio"
                        renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}

                    />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                    <DatePicker
                        value={finalDate}
                        onChange={(newValue) => { setFinalDate(newValue) }}
                        label="Fim"
                        renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
                    />
                </LocalizationProvider>

                <FormControl style={{minWidth: '200px'}}>
                    <InputLabel id="demo-multiple-checkbox-label">Usuarios</InputLabel>
                    <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={personName}                        
                        onChange={handleChange}
                        input={<OutlinedInput label="Usuarios" />}
                        renderValue={(selected) => {
                            if (selected.length === nomesUnicos.length || selected.includes("Todos")) {
                                return "Todos";
                            }
                            return selected.join(", ");
                        }}
                        MenuProps={MenuProps}
                    >
                        {/* Opção "Todos" */}
                        <MenuItem key="Todos" value="Todos">
                            <Checkbox checked={personName.length === nomesUnicos.length || personName.includes("Todos")} />
                            <ListItemText primary="Todos" />
                        </MenuItem>

                        {/* Nomes individuais */}
                        {nomesUnicos?.map((nome) => (
                        <MenuItem key={nome} value={nome}>
                            <Checkbox checked={personName.includes(nome)} />
                            <ListItemText primary={nome} />
                        </MenuItem>
                    ))}
                    </Select>                    
                </FormControl>

                <Button className="buttonHover" onClick={handleGetTicketsInformation} variant='contained'>Filtrar</Button>

            </Stack>
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
        </>
    );
}